<template>
  <div class="enterporise_list">
    <div class="container">
      <el-card :body-style="{ padding: '12px 16px' }">
        <el-form label-width="100px">
          <el-form-item label="所在地区：">
            <CascaderArea
              :country="queryInfo.userCountry"
              :province="queryInfo.userProvince"
              :city="queryInfo.userCity"
              @searchArae="searchArae"
              class="CascaderArea"
            />
          </el-form-item>
          <el-form-item label="渠道类型：">
            <div>
              <el-radio-group v-model="queryInfo.userType" size="medium" @input="changeUserType">
                <el-radio-button :label="null">全部</el-radio-button>
                <el-radio-button :label="0">个人</el-radio-button>
                <el-radio-button :label="1">企业</el-radio-button>
              </el-radio-group>
            </div>
          </el-form-item>
          <el-form-item label="审核状态：">
            <div>
              <el-radio-group v-model="queryInfo.reviewStatus" size="medium" @input="changeStatus">
                <el-radio-button :label="2">全部</el-radio-button>
                <el-radio-button :label="1"
                  >已审核 <span>({{ reviewStatusArr[1].reviewCount }})</span></el-radio-button
                >
                <el-radio-button :label="0"
                  >未审核 <span>({{ reviewStatusArr[2].noReviewCount }})</span></el-radio-button
                >
              </el-radio-group>
            </div>
          </el-form-item>
          <div class="enterporise_list_input_add">
            <el-button type="primary" class="add_enterprise" @click="addUsers">新增</el-button>
            <div class="input_new">
              <el-input
                placeholder="请输入用户名称"
                v-model="queryInfo.name"
                clearable
                class="input-with-select"
                @change="cleanSearch"
              >
                <el-button slot="append" @click="searchUsers">搜索</el-button>
              </el-input>
            </div>
          </div>
        </el-form>
      </el-card>
      <!-- 数据排序 -->
      <div class="orderData">
        <p class="num">
          共查出<span>{{ total }}</span
          >条数据
        </p>
        <div class="upload_time">
          <div class="caretTime" @click="uploadStatus">按审核状态排序</div>
          <div class="san">
            <i
              class="el-icon-caret-top"
              :class="[
                queryInfo.columnName == 1 && queryInfo.order == 0 ? 'isActiveTime1' : 'iconColor'
              ]"
              @click="uploadStatus"
            />
            <i
              class="el-icon-caret-bottom"
              :class="[
                queryInfo.columnName == 1 && queryInfo.order == 1 ? 'isActiveTime1' : 'iconColor'
              ]"
              @click="uploadStatus"
            />
          </div>
        </div>
        <div class="upload_time">
          <div class="caretTime" @click="uploadAddtime">按新增时间排序</div>
          <div class="san">
            <i
              class="el-icon-caret-top"
              :class="[
                queryInfo.columnName == 2 && queryInfo.order == 0 ? 'isActiveTime1' : 'iconColor'
              ]"
              @click="uploadAddtime"
            />
            <i
              class="el-icon-caret-bottom"
              :class="[
                queryInfo.columnName == 2 && queryInfo.order == 1 ? 'isActiveTime1' : 'iconColor'
              ]"
              @click="uploadAddtime"
            />
          </div>
        </div>
      </div>
      <el-card
        style="margin-top: 12px"
        v-for="(item, index) in jingyiUserData"
        :key="index"
        class="contentInfo"
      >
        <!-- 编号 -->
        <div class="number">{{ item.uniqueId }}</div>
        <div>
          <div class="listStyle flexOne">
            <div class="flexAround">
              <div class="flexAround">
                <!-- 头像 -->
                <div>
                  <img
                    :src="item.headPortrait"
                    alt=""
                    v-if="item.headPortrait"
                    @click="viewItem(item)"
                  />
                  <img :src="pro" alt="" v-else @click="viewItem(item)" />
                </div>
                <!-- 左边模块 -->
                <div class="info">
                  <!-- 企业名称 -->
                  <div class="companyName">
                    <span v-show="item.reviewStatus == 0">待审核</span>
                    <!-- <span v-show="item.reviewStatus == 1">审核成功</span> -->
                    <span v-show="item.reviewStatus == 2">审核不通过</span>
                    <!-- <span v-show="item.reviewStatus == 3">无审核信息</span> -->
                    <!-- <span v-show="item.state == 0">停用</span> -->
                    <p v-if="item.userType == 1">{{ item.companyName }}</p>
                    <p v-if="item.userType == 0">{{ item.name }}</p>
                  </div>
                  <!-- 擅长领域 -->
                  <div class="technique" v-if="item.technique">
                    <img src="../../../src/assets/icons/Group.png" alt="" />
                    <span>
                      擅长领域：
                      <el-popover
                        placement="bottom-start"
                        width="200"
                        trigger="hover"
                        :content="item.technique"
                        popper-class="monitor-yt-popover"
                      >
                        <span style="color: rgba(61, 125, 248, 1)" slot="reference">{{
                          item.technique
                        }}</span>
                      </el-popover>
                    </span>
                  </div>
                  <!-- 状态 -->
                  <div class="reviewStatus" v-if="item.reviewStatus">
                    <div v-show="item.reviewStatus == 3" style="color: #ff8c06">
                      <i class="el-icon-warning"></i>
                      <span>该用户未提交信息审核</span>
                    </div>
                    <div v-show="item.reviewStatus == 2" style="color: #f53939">
                      <i class="el-icon-warning"></i>
                      <span>该用户信息审核未通过</span>
                    </div>
                    <!-- <div v-show="item.state == 0" style="color: #333333">
                      <i class="el-icon-warning"></i>
                      <span>该账号已停用</span>
                    </div> -->
                  </div>
                  <!-- 姓名 电话 地址 -->
                  <div class="userInfo">
                    <!--                    <span class="in" v-if="item.name">{{ item.name }}</span>-->
                    <!--                    <span class="in" v-if="item.phone">{{ maskNumber(item.phone) }}</span>-->
                    <p class="in">
                      <span v-if="item.userProvince">{{ item.userProvince }}</span>
                      <span v-if="item.userCity">{{ '-' + item.userCity }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="right">
              <div class="rejectionReason">
                <!--                <div class="y" v-if="item.reviewStatus == 1">-->
                <!--                  <img src="../../../assets/images/yes1.png" alt="" />-->
                <!--                </div>-->
                <div class="n" v-if="item.reviewStatus == 2">
                  <img src="../../assets/images/no1.png" alt="" />
                  <div>{{ item.rejectionReason }}</div>
                </div>
              </div>
              <!--              <div class="rejectionReason" v-if="item.reviewStatus == 2">-->
              <!--                <div>-->
              <!--                  <i class="el-icon-error"></i>-->
              <!--                  <span style="padding-left: 6px">审核不通过</span>-->
              <!--                </div>-->
              <!--                <div style="margin-top: 8px">-->
              <!--                  <span>理由：</span>-->
              <!--                  <span>{{ item.rejectionReason }}</span>-->
              <!--                </div>-->
              <!--              </div>-->
              <div v-if="item.reviewStatus !== 2"></div>
              <div class="operation">
                <div style="display: flex; align-items: center">
                  <div
                    class="flexNormal auditing"
                    style="margin-right: 20px"
                    @click="toAuditing(item)"
                    v-if="!item.reviewStatus == 1 || !item.reviewStatus || !item.reviewStatus == 2"
                  >
                    <i icon="icon-jr-icon-modify" text="进入审核" />
                    <span style="color: #17757a">审核</span>
                  </div>
                  <div class="flexNormal" style="margin-right: 10px" @click="editItem(item)">
                    <i icon="icon-jr-icon-modify" text="详情" />
                    <span style="color: #17757a">编辑</span>
                  </div>
                  <div style="margin-right: 10px" v-if="false">
                    <span v-if="item.state == 1" class="frozen" @click="delUsers(item)">冻结</span>
                    <span v-if="item.state == 0" class="frozen" @click="cancelUsers(item)"
                      >激活</span
                    >
                  </div>
                  <div class="flexNormal frozen">
                    <!--                    <i icon="icon-jr-icon-modify" text="删除" />-->
                    <!-- <span style="color: #fd5469">删除</span> -->
                    <!--                    <el-button type="text" @click="delItem(item)" style="color: #fd5469"-->
                    <!--                      >删除</el-button-->
                    <!--                    >-->
                    <div type="text" @click="delItem(item)" style="color: #fd5469">删除</div>
                  </div>
                </div>
                <span class="pos" style="font-size: 14px; color: rgba(153, 153, 153, 1)"
                  >新增时间：{{ item.createTime }}</span
                >
              </div>
            </div>

            <!-- <div class="bottomFont">
              <p style="font-size: 13px">信息来源：{{ item.skills }}</p>
              <p style="font-size: 13px">最近更新时间：{{ item.updateTime }}</p>
            </div> -->
          </div>
        </div>
      </el-card>
    </div>
    <div class="page_nation pagination">
      <el-pagination
        :current-page="queryInfo.pageNum"
        :page-sizes="[30, 50, 100]"
        :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!-- 添加用户弹窗 -->
    <el-dialog
      :visible.sync="dialogVisibleadd"
      width="40%"
      :before-close="addhandleClose"
      class="dialog"
    >
      <div style="display: flex; align-items: center">
        <div
          class="line"
          style="
            width: 4px;
            height: 20px;
            border-radius: 4px;
            background-color: rgba(23, 117, 122, 1);
            margin-right: 10px;
          "
        ></div>
        <div slot="title" style="font-size: 18px; color: rgba(51, 51, 51, 1); font-weight: 550">
          添加菁亿用户
        </div>
      </div>
      <div style="padding: 30px">
        <el-form
          ref="usersForm"
          :rules="usersFormRules"
          :model="usersForm"
          label-position="right"
          label-width="100px"
          :show-message="false"
        >
          <div style="display: flex; justify-content: space-between; margin-bottom: 8px">
            <el-form-item label="用户类型：" prop="userType">
              <el-radio-group v-model="usersForm.userType" @input="changeMessage">
                <el-radio label="0">个人用户</el-radio>
                <el-radio label="1">企业用户</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否启用：" style="width: 44%">
              <div class="jihuo">
                <el-switch
                  v-model="usersForm.state"
                  active-color="rgba(23, 117, 122, 1)"
                  inactive-color="#DCDFE6"
                  active-value="1"
                  inactive-value="0"
                  active-text="启用"
                  :width="60"
                >
                </el-switch>
              </div>
            </el-form-item>
          </div>
          <div style="display: flex; justify-content: space-between; margin-bottom: 8px">
            <el-form-item
              label="用户名："
              prop="name"
              v-if="usersForm.userType == '0' || !usersForm.userType"
            >
              <div style="display: flex; flex-direction: column">
                <el-input v-model="usersForm.name" placeholder="请输入"></el-input>
                <span style="color: #f56c6c; line-height: 22px" v-if="!usersForm.name">{{
                  msgUserTips
                }}</span>
              </div>
            </el-form-item>
            <el-form-item label="企业名称：" prop="companyName" v-if="usersForm.userType == '1'">
              <div style="display: flex; flex-direction: column">
                <el-input
                  v-model="usersForm.companyName"
                  placeholder="请输入"
                  style="width: 187px"
                ></el-input>
                <span style="color: #f56c6c; line-height: 22px" v-if="!usersForm.companyName">{{
                  msgCompanyTips
                }}</span>
              </div>
            </el-form-item>
            <div style="display: flex; flex-direction: column; width: 44%">
              <el-form-item label="性别：" prop="gender">
                <el-radio-group v-model="usersForm.gender">
                  <el-radio :label="1">男</el-radio>
                  <el-radio :label="0">女</el-radio>
                </el-radio-group>
              </el-form-item>
              <span
                style="color: #f56c6c; line-height: 22px; margin-left: 100px"
                v-if="!usersForm.gender"
                >{{ msgGenderTips }}</span
              >
            </div>
          </div>
          <div style="display: flex; justify-content: space-between; margin-bottom: 8px">
            <el-form-item label="英文名：">
              <div style="display: flex; flex-direction: column">
                <el-input v-model="usersForm.nameEnglish" placeholder="请输入"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="邮箱：" prop="mail" style="width: 44%">
              <el-input
                v-model="usersForm.mail"
                placeholder="请输入"
                style="width: 187px"
              ></el-input>
              <span style="color: #f56c6c; line-height: 22px" v-if="!usersForm.mail">{{
                msgMailTips
              }}</span>
            </el-form-item>
          </div>
          <div style="display: flex; justify-content: space-between; margin-bottom: 8px">
            <el-form-item label="联系电话：" prop="phone">
              <div style="display: flex; flex-direction: column">
                <el-input
                  v-model="usersForm.phone"
                  placeholder="请输入"
                  maxlength="11"
                  style="width: 187px"
                ></el-input>
                <span style="color: #f56c6c; line-height: 22px" v-if="!usersForm.phone">{{
                  msgPhoneTips
                }}</span>
                <span
                  style="color: #f56c6c; line-height: 22px"
                  v-if="usersForm.phone && usersForm.phone.length !== 11"
                  >{{ msgPhoneTips1 }}</span
                >
              </div>
            </el-form-item>
            <el-form-item label="微信号：" style="margin-left: 40px; width: 44%">
              <div style="display: flex; flex-direction: column">
                <el-input
                  v-model="usersForm.weChat"
                  placeholder="请输入"
                  style="width: 187px"
                ></el-input>
              </div>
            </el-form-item>
          </div>
          <div style="display: flex; flex-direction: column; margin-bottom: 8px">
            <el-form-item
              label="所在地区："
              prop="userCountry"
              :rules="[
                { required: true, message: '请输入', trigger: 'blur' },
                {
                  validator: (rules, value, callback) =>
                    validatorEnumsLabel(rules, value, callback),
                  trigger: 'blur',
                  required: true
                }
              ]"
            >
              <CascaderArea
                :country="usersForm.userCountry"
                :province="usersForm.userProvince"
                :city="usersForm.userCity"
                class="CascaderArea"
                @searchArae="searchAraeUsers"
              />
            </el-form-item>
            <span
              style="color: #f56c6c; line-height: 22px; margin-left: 100px"
              v-if="!usersForm.userCountry || !usersForm.userProvince || !usersForm.userCity"
              >{{ msgAddressTips }}</span
            >
          </div>
          <div style="display: flex; justify-content: space-between">
            <el-form-item label="默认密码：" style="width: 50%; color: rgba(249, 138, 35, 1)">
              admin
            </el-form-item>
          </div>
          <!-- <div style="display: flex"> -->
          <!-- <el-form-item label="企业名称：" prop="companyName" v-if="usersForm.userType == '1'">
              <div style="display: flex; flex-direction: column">
                <el-input
                  v-model="usersForm.companyName"
                  placeholder="请输入"
                  style="width: 187px"
                ></el-input>
                <span style="color: #f56c6c; line-height: 22px" v-if="!usersForm.companyName">{{
                  msgCompanyTips
                }}</span>
              </div>
            </el-form-item> -->
          <!-- </div> -->
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveUsers">保 存</el-button>
        <el-button @click="addhandleClose">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 分页查询 / 新增 / 审核数量 / 冻结/停用 / 取消冻结/启用 / 删除
import { list, add, reviewCnt, stop, start, deleteItem } from '@/api/jingyiUsers.js'
// ----------

import { pagination } from '@/mixins/pagination'
import CascaderArea from '@/components/CascaderArea.vue'
// import { getCompanyLists, deleteCompanyId } from '@/api/enterprise.js'
const defaultQueryObj = Object.freeze({
  pageNum: 0, //页数
  pageSize: 30, //大小
  columnName: '', //排序字段(1、审核状态；2、新增时间
  name: '', //查询企业或姓名
  order: '', //排序(1、降序；0、升序)
  reviewStatus: 2, //审核状态：0 未审核 1 已审核 2 全部
  userCountry: '中国', //所在国家
  userProvince: '', //所在省份
  userCity: '', //所在城市
  userType: null //用户类型：0 个人用户 1 企业用户
})
export default {
  components: { CascaderArea },
  name: 'enterpriseList',
  mixins: [pagination],
  data() {
    return {
      msgPhoneTips1: '', //判断提示语展示不展示
      msgPhoneTips: '', // 判断提示语展示不展示
      msgUserTips: '', // 判断提示语展示不展示
      msgMailTips: '', //判断提示语展示不展示
      msgCompanyTips: '', //判断提示语展示不展示
      msgAddressTips: '', //判断提示语展示不展示
      msgGenderTips: '', //判断提示语展示不展示
      queryInfo: { ...defaultQueryObj }, //查询参数
      noLimit: [],
      codeData: [], //项目数据循环
      jingyiUserData: [], //表格数据
      statusI: 1, //按审核状态排序
      addTimeI: 1, //安新增时间排序
      dialogVisibleadd: false, //展示弹窗
      addProjectDialogShow: false, // 添加项目弹窗
      //添加用户表单
      usersForm: {
        userCode: '', //用户编码
        userType: '0', //用户类型：0 个人用户 1 企业用户
        name: '', //用户名
        companyName: '', //企业名称
        phone: '', //联系电话
        state: '1', //是否启用: 0 停用 1启用
        nameEnglish: '', //英文名
        weChat: '', //微信号
        userCountry: '中国', //所在国家
        userProvince: '', //所在省份
        userCity: '', //所在城市
        mail: '', //邮箱
        gender: 1 //性别
      },
      //添加用户表单校验
      usersFormRules: {
        userType: [{ required: true, message: '请选择用户类型', trigger: 'change' }],
        name: [{ required: true, message: '请输入用户名', trigger: 'change' }],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { min: 11, max: 11, message: '请输入正确联系电话', trigger: 'blur' }
        ],
        companyName: [{ required: true, message: '请输入企业名称', trigger: 'change' }],
        mail: [{ required: true, message: '请输入邮箱', trigger: 'change' }],
        gender: [{ required: true, message: '请选择性别', trigger: 'change' }]
      },
      // 审核状态数组++
      reviewStatusArr: [
        {
          label: 2,
          text: '全部'
        },
        {
          label: 1,
          text: '已审核',
          reviewCount: 0
        },
        {
          label: 0,
          text: '未审核',
          noReviewCount: 0
        }
      ]
    }
  },
  created() {
    this.search()
    this.reviewCn()
  },
  watch: {
    'usersForm.name': {
      handler(newVal, oldVal) {
        if (newVal == '') {
          this.msgUserTips = '请输入用户名'
        } else {
          this.msgUserTips = ''
        }
      }
    },
    'usersForm.companyName': {
      handler(newVal, oldVal) {
        if (newVal == '') {
          this.msgCompanyTips = '请输入企业名称'
        } else {
          this.msgCompanyTips = ''
        }
      }
    },
    'usersForm.phone': {
      handler(newVal, oldVal) {
        if (newVal == '') {
          this.msgPhoneTips = '请输入联系方式'
        } else if (newVal.length !== '11') {
          this.msgPhoneTips1 = '请输入正确的联系方式'
        } else {
          this.msgPhoneTips = ''
          this.msgPhoneTips1 = ''
        }
      }
    },
    'usersForm.mail': {
      handler(newVal, oldVal) {
        if (newVal == '') {
          this.msgMailTips = '请输入邮箱'
        } else {
          this.msgMailTips = ''
        }
      }
    },
    'usersForm.msgGenderTips': {
      handler(newVal, oldVal) {
        if (newVal == '') {
          this.msgGenderTips = '请选择性别'
        } else {
          this.msgGenderTips = ''
        }
      }
    }
  },
  methods: {
    // 改变状态 0个人企业 1用户企业
    changeMessage(val) {
      // if (val == 0) {
      //   this.msgUserTips = '请输入用户名'
      //   this.msgPhoneTips = '请输入联系方式'
      //   this.msgMailTips = '请输入邮箱'
      //   this.msgGenderTips = '请选择性别'
      //   this.msgAddressTips = '请选择所在地区'
      // } else {
      //   this.msgUserTips = ''
      // }
      // if (val == 1) {
      //   this.msgCompanyTips = '请输入企业名称'
      //   this.msgPhoneTips = '请输入联系方式'
      //   this.msgMailTips = '请输入邮箱'
      //   this.msgGenderTips = '请选择性别'
      //   this.msgAddressTips = '请选择所在地区'
      // } else {
      //   this.msgCompanyTips = ''
      // }
    },
    //审核数量查询
    async reviewCn() {
      const { data } = await reviewCnt()
      if (data.resultCode == 200) {
        this.reviewStatusArr[1].reviewCount = data.data[2]
        this.reviewStatusArr[2].noReviewCount = data.data[1]
      }
    },
    //渠道类型筛选
    changeUserType(type) {
      this.queryInfo.pageNum = 1
      if (type) {
        this.queryInfo.userType = type
      }
      this.search()
    },
    //审核状态筛选
    changeStatus(status) {
      this.queryInfo.pageNum = 1
      if (status) {
        this.queryInfo.reviewStatus = status
      }
      this.search()
      this.reviewCn()
    },
    //分页查询
    async search() {
      const { data: res } = await list(this.queryInfo)
      if (res.resultCode === 200) {
        this.jingyiUserData = res.data.list
        this.total = res.data.total
      }
    },
    // 按审核状态排序 1、审核状态；2、新增时间
    uploadStatus() {
      this.queryInfo.pageNum = 1
      switch (this.statusI) {
        case 0:
          this.queryInfo.columnName = ''
          this.queryInfo.order = '0'
          this.statusI++
          break
        case 1:
          this.queryInfo.columnName = '1'
          this.queryInfo.order = '0'
          this.statusI++
          break
        case 2:
          this.queryInfo.columnName = '1'
          this.queryInfo.order = '1'
          this.statusI = 0
          break
      }
      this.search()
    },
    //按新增时间排序 1、审核状态；2、新增时间
    uploadAddtime() {
      this.queryInfo.pageNum = 1
      switch (this.addTimeI) {
        case 0:
          this.queryInfo.columnName = ''
          this.queryInfo.order = '0'
          this.addTimeI++
          break
        case 1:
          this.queryInfo.columnName = '2'
          this.queryInfo.order = '0'
          this.addTimeI++
          break
        case 2:
          this.queryInfo.columnName = '2'
          this.queryInfo.order = '1'
          this.addTimeI = 0
          break
      }
      this.search()
    },
    // 清空项目搜索框
    cleanSearch(val) {
      if (val == '') this.search()
    },
    //输入框搜索
    searchUsers() {
      this.queryInfo.pageNum = 1
      this.queryInfo.pageSize = 30
      this.search()
    },
    //监听pagesize变化
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize
      this.search()
    },
    //监听页码变化
    handleCurrentChange(newCurrent) {
      this.queryInfo.pageNum = newCurrent
      this.search()
    },
    //冻结
    delUsers(row) {
      const params = {
        userCode: row.userCode
      }
      this.$alert('您是否确认冻结？')
        .then(function () {
          return stop(params)
        })
        .then(() => {
          this.search()
          this.$message.success('冻结成功')
        })
        .catch(() => {})
    },
    //激活
    cancelUsers(row) {
      const params = {
        userCode: row.userCode
      }
      this.$alert('您是否确认激活？')
        .then(function () {
          return start(params)
        })
        .then((res) => {
          if (res.data.resultCode == 200) {
            this.search()
            this.$message.success('激活成功')
          } else {
            this.$message.warning(res.data.message)
          }
        })
        .catch(() => {})
    },
    //新增 弹框显示
    addUsers() {
      this.dialogVisibleadd = true
      this.addProjectDialogShow = true
      this.usersForm.userCountry = '中国'
      // this.currentErpriseName = ''
      // this.positionList = []
    },
    //新增
    saveUsers() {
      this.$refs.usersForm.validate(async (valid) => {
        if (valid) {
          this.msgUserTips = ''
          this.msgCompanyTips = ''
          this.msgPhoneTips = ''
          this.msgPhoneTips1 = ''
          const { data } = await add(this.usersForm)
          if (data.resultCode == 200) {
            this.usersForm.userCode = data.data
            this.$message.success(data.message)
            this.dialogVisibleadd = false
            this.search()
            this.usersForm = {}
          } else {
            this.$message.error(data.message)
          }
        } else {
          this.msgUserTips = '请输入用户名'
          this.msgCompanyTips = '请输入企业名称'
          this.msgPhoneTips = '请输入联系方式'
          this.msgMailTips = '请输入邮箱'
          this.msgAddressTips = '请选择所在地区'
          this.msgGenderTips = '请选择性别'
        }
      })
    },
    // 新增 弹窗关闭
    addhandleClose() {
      this.dialogVisibleadd = false
      this.usersForm = {}
      this.usersForm.state = '1'
      this.usersForm.gender = 1
      this.usersForm.userType = '0'
      this.msgUserTips = ''
      this.msgCompanyTips = ''
      this.msgPhoneTips = ''
      this.msgPhoneTips1 = ''
      this.msgAddressTips = ''
      this.msgMailTips = ''
      this.msgGenderTips = ''
    },
    // 查询
    searchArae(val) {
      this.queryInfo.userCountry = val.country
      this.queryInfo.userProvince = val.province
      if (val.city != '北京' && val.city != '天津' && val.city != '上海' && val.city != '重庆') {
        this.queryInfo.userCity = val.city
      }
      this.search()
    },
    // 进入审核
    toAuditing(row) {
      this.$router.push({
        path: '/jingyiUsers/auditing',
        query: {
          userCode: row.userCode,
          reviewCode: row.reviewCode
          // searchInfo: JSON.stringify(this.queryInfo)
        }
      })
    },
    //编辑企业
    editItem(row) {
      this.$router.push({
        path: '/jingyiUsers/usersDetail',
        query: {
          userCode: row.userCode,
          reviewCode: row.reviewCode,
          reviewStatus: row.reviewStatus
          // usersForm: JSON.stringify(this.usersForm)
        }
      })
    },
    viewItem(row) {
      // if (this.editHasPermission) {
      //   this.$router.push({
      //     name: 'TalentMessageView',
      //     query: {
      //       id: row.personCode,
      //       clientType: 1,
      //       searchInfo: JSON.stringify(this.queryInfo)
      //     }
      //   })
      // } else {
      //   this.$message.warning('暂无权限')
      // }
    },
    // 电话号码隐藏中间四位
    maskNumber(number) {
      return number.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
    },
    // 删除
    delItem(row) {
      this.$confirm('删除后不可恢复，请确认是否删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const params = [row.tenantId]
          deleteItem(params).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.reviewCn()
            this.search()
          })
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // })
        })
    },
    // 弹窗选择所在地区赋值
    searchAraeUsers(val) {
      this.usersForm.userCountry = val.country
      this.usersForm.userProvince = val.province
      if (val.city != '北京' && val.city != '天津' && val.city != '上海' && val.city != '重庆') {
        this.usersForm.userCity = val.city
      }
      if (val) {
        this.msgAddressTips = ''
      }
    },
    //所在地区校验
    validatorEnumsLabel(rules, value, callback) {
      if (!this.usersForm.userCountry || !this.usersForm.userProvince || !this.usersForm.userCity) {
        this.msgAddressTips = '请选择所在地区'
      } else {
        this.msgAddressTips = ''
        callback()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  height: 82vh;
  overflow: scroll;
  font-family: PingFang SC;
}
.pagination {
  width: 100%;
  text-align: center;
  margin: 10px 0 20px 0;
}

/deep/ .el-image__inner {
  border-radius: 5px;
}

// /deep/ .el-input__inner {
//   border-color: #17757a;
// }

.dialog {
  /deep/ .el-input__inner {
    border-color: #dcdfe6 !important;
    color: #606266 !important;
  }
}

.el-table {
  /deep/tbody tr:hover > td {
    // background-color: #90c0f1;
    background-color: rgba(23, 117, 122, 0.1);
  }
}

.add_enterprise {
  width: 85px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 4px 0 0 12px;
}
.enterporise_list_input_add {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  /deep/ .input-with-select {
    margin-right: 50px;
  }
  .input_new {
    /deep/ .el-button {
      border-radius: 0 4px 4px 0;
      height: 40px;
    }

    /deep/ .el-button--default {
      background-color: #17757a;
      color: #fff;
    }
  }

  .add_enterprise {
    background-color: #17757a;
    border-color: #17757a;
  }
}

.enterprise_table {
  margin-top: 20px;
  width: 100%;

  .no_cooperation {
    box-sizing: border-box;
    padding: 2px 4px;
    border-radius: 4px;
    color: #ffb847;
    background-color: rgba(255, 184, 71, 0.2);
    border: 1px solid #ffb847;
  }

  .in_cooperation {
    box-sizing: border-box;
    padding: 2px 4px;
    border-radius: 4px;
    color: #17757a;
    background-color: rgba(23, 117, 122, 0.2);
    border: 1px solid #17757a;
  }

  .to_be_renewed {
    box-sizing: border-box;
    padding: 2px 4px;
    border-radius: 4px;
    color: #4d70fa;
    background-color: rgba(77, 112, 250, 0.2);
    border: 1px solid #4d70fa;
  }

  .el_image {
    width: 48px;
    height: 48px;
    border-radius: 4px;
  }

  .operation_bottom {
    .operation_border {
      font-size: 18px;
      color: #e8e8e8;
    }
  }
}

.CascaderArea {
  /deep/ .el-input__inner {
    border: 1px solid #17757a;
    color: #17757a;
    height: 34px;
    line-height: 34px;
  }
}
/deep/ .el-form-item {
  margin-bottom: 5px;
}
/deep/ .el-radio-button__inner {
  border: 1px solid #fff !important;
  padding: 9px 10px;
  border-radius: 4px;
}
/deep/ .el-radio-button__inner:hover {
  color: #17757a;
  border-radius: 4px;
}
/deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: #fff;
  color: #17757a;
  border: 1px solid #17757a !important;
  box-shadow: none;
}
/deep/ .el-radio-button.is-checked .el-radio-button__inner {
  box-shadow: none;
}
.buttonContent {
  display: flex;
}

.contentInfo {
  position: relative;
  .number {
    top: 0;
    left: 0;
    position: absolute;
    width: 121px;
    height: 20px;
    border-radius: 0px 4px 0px 4px;
    color: rgba(23, 117, 122, 1);
    background: rgba(230, 250, 250, 1);
    border: 1px solid rgba(217, 242, 242, 1);
    text-align: center;
    font-size: 14px;
  }
  /deep/ .el-card__body {
    padding: 12px;
  }
}
.listStyle {
  .rejectionReason {
    .n {
      display: flex;
      justify-content: center;
      div {
        text-align: center;
        line-height: 60px;
      }
      img {
        width: 76px;
        height: 60px;
      }
    }
    //flex-direction: column;
    //justify-content: center;
    font-size: 14px;
    font-weight: 400;
    color: rgba(250, 80, 80, 1);
  }

  img {
    width: 60px;
    height: 60px;
    // margin: 8px 0 0 0;
    // padding: 5px;
    cursor: pointer;
    border-radius: 5px;
  }

  .timeline {
    // margin-left: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    /deep/ .el-timeline {
      display: flex;
      flex-direction: column;

      .el-timeline-item {
        padding: 20px 0 0 0;
      }
    }
  }
}
.flexOne {
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
}
.flexAround {
  display: flex;
  //align-items: center;

  .jobTitle {
    font-size: 20px;
    font-weight: 600;
    display: flex;
    justify-items: center;
  }

  .positionType {
    color: #333333;
  }

  span {
    display: inline-block;
  }
}
.cloumFlex {
  width: 350px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.operation {
  justify-content: flex-end;
  width: 200px;
  position: relative;
  display: flex;
  //align-items: center;
  align-items: flex-start;
  margin-left: 40px;
  height: 100%;
  .pos {
    width: 316px;
    position: absolute;
    bottom: -8px;
    right: -108px;
  }
}
.auditing {
  width: 84px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: 1px solid #17757a;
}
.info {
  //display: flex;
  margin-left: 18px;
  .companyName {
    font-size: 18px;
    font-weight: 600;
    color: #151515;
    display: flex;
    align-items: center;
    span {
      padding: 2px 6px;
      font-size: 10px;
      font-weight: 600;
      line-height: 14px;
      text-align: left;
      border-radius: 10px;
      line-height: 18px;
      text-align: center;
    }
    p {
      margin-left: 6px;
    }
    span:nth-child(1) {
      background: #fdf6ec;
      color: #e6a23c;
    }
    span:nth-child(2) {
      background: #fef0f0;
      color: #f56c6c;
    }
    span:nth-child(3) {
      background: #f0f9eb;
      color: #67c23a;
    }
    span:nth-child(4) {
      background: #ecf5ff;
      color: #409eff;
    }
    span:nth-child(5) {
      background: #f4f4f5;
      color: #909399;
    }
  }

  .technique {
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    padding: 5px 0;
    display: flex;
    align-items: center;

    img {
      width: 16px;
      height: 16px;
      margin-right: 2px;
    }
  }

  .reviewStatus {
    margin: 4px 0;
    div {
      display: flex;
      align-items: center;
      margin: 0 0 3px 0;
    }
    i {
      margin-right: 6px;
      width: 16px;
      height: 16px;
    }
    span {
      font-size: 14px;
    }
  }

  .userInfo {
    display: flex;
    align-items: center;
    span {
      font-size: 14px;
      font-weight: 400;
      text-align: left;
      color: #333333;
    }
    .in {
      padding-right: 16px;
      display: flex;
      align-items: center;
    }
  }
}
.orderData {
  margin-top: 12px;
  display: flex;
  .num {
    font-size: 16px;
    font-weight: 400;
    text-align: left;
    span {
      color: rgba(23, 117, 122, 1);
    }
  }
}
.upload_time {
  display: flex;
  align-items: center;
  position: relative;
  margin-left: 32px;
  .san {
    margin-left: 6px;
    i {
      display: block;
      font-size: 14px;
      position: absolute;
    }
    i:nth-child(1) {
      top: 0;
    }
    i:nth-child(2) {
      top: 7px;
    }
  }
}
.caretTime:hover {
  cursor: pointer;
}
.isActiveTime1 {
  color: rgba(23, 117, 122, 1) !important;
}
.iconColor {
  color: #c0c4cc !important;
}
::v-deep .el-dialog__footer {
  .dialog-footer {
    display: flex;
    justify-content: center;
  }
}
.frozen {
  padding-left: 20px;
  color: #fd5469;
  cursor: pointer;
}
.right {
  width: 40%;
  display: flex;
  justify-content: space-between;
}
.jihuo {
  position: relative;
  z-index: 999;
  span {
    position: absolute;
    font-size: 12px;
    padding: 0 2px;
    color: #fff;
    left: 0;
    z-index: 0;
  }
}
/deep/ .el-switch__core {
  padding: 4px 0 !important;
}
</style>

<style lang="less" scoped>
/* //最外层div,修改背景色，边框 */
.el-popover.monitor-yt-popover {
  opacity: 0.9;
}
/* //修改title颜色 */
.monitor-yt-popover .el-popover__title {
  color: white;
}
/* //修改下面的小三角，属性名根据组件的placement位置做相应修改 */
.monitor-yt-popover .popper__arrow::after {
  border-top-color: #090d29 !important;
}
::v-deep .el-main {
  padding: 0 10px 10px 10px !important;
}

/* 媒体查询：自适应 */
// 1680x1050 (1680x889)
@media (max-width: 1682px) and (max-height: 890px) {
  .container {
    max-height: 81vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1600x900 (1600x739)
@media (max-width: 1602px) and (max-height: 740px) {
  .container {
    max-height: 78vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1366x768 (1366x607)
@media (max-width: 1368px) and (max-height: 608px) {
  .container {
    max-height: 73vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1280x960 (1280x799)
@media (max-width: 1282px) and (max-height: 800px) {
  .container {
    max-height: 80vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1280x800 (1280x639)
@media (max-width: 1282px) and (max-height: 640px) {
  .container {
    max-height: 74vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1280x768 (1280x607)
@media (max-width: 1282px) and (max-height: 608px) {
  .container {
    max-height: 73vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1280x720 (1280x599)
@media (max-width: 1282px) and (max-height: 600px) {
  .container {
    max-height: 71vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1280x600 (1280x439)
@media (max-width: 1282px) and (max-height: 440px) {
  .container {
    max-height: 63vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1152x864 (1152x703)
@media (max-width: 1153px) and (max-height: 704px) {
  .container {
    max-height: 77vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1024x768 (1024x607)
@media (max-width: 1025px) and (max-height: 608px) {
  .container {
    max-height: 73vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 800x600 (800x439)
@media (max-width: 801px) and (max-height: 440px) {
  .container {
    max-height: 63vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}
</style>
